// extracted by mini-css-extract-plugin
module.exports = {"FilterAddon__indicator":"FilterAddon__indicator__1-PwG"};